// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		
		imgType:"",
		text:'',
	},
	getters: {
		
	},
	mutations: {
		set_imgType(state, params) {
			state.imgType = params;
		},
		set_text(state, params) {
			state.text = params;
		},
	},
	actions: {

	},
};
